import { useState } from 'react';
import { Taxonomy } from 'app/components/editor/sidebar/tags/taxonomy/Taxonomy';
import { i18n } from 'app/utils/i18n';

export interface AnchorPickerResult {
  /** Concept QName, e.g. "ifrs-full:PropertyPlantAndEquipment". Resolved to a
   * UUID via useConcept at submit time. */
  conceptName: string;
}

type AnchorPickerProps = {
  /** Wider anchor must resolve to a standard concept (ESEF rule — no
   * chain-of-extensions). Narrower anchors may reference either. */
  anchorKind: 'wider' | 'narrower';
  onSelect: (picked: AnchorPickerResult) => void;
  onClose: () => void;
  selected?: string | null;
};

export const AnchorPicker = ({ anchorKind, onSelect, onClose, selected }: AnchorPickerProps) => {
  const [localSelected, setLocalSelected] = useState<string | null>(selected || null);
  const hideExtensions = anchorKind === 'wider';

  return (
    <div className="new-extension__taxonomy">
      <Taxonomy
        selectedTagId={localSelected}
        isContentMarked={false}
        usedTags={[]}
        documentTags={[]}
        hideExtensions={hideExtensions}
        hideFooter
        onSelectionChange={(tag) => setLocalSelected(tag?.id ?? null)}
      />

      <div className="new-extension__footer-actions">
        <button type="button" onClick={onClose} className="btn btn-secondary">
          {i18n('common.cancel')}
        </button>
        <button
          type="button"
          className="btn btn-primary"
          disabled={!localSelected}
          onClick={() => {
            if (localSelected) {
              onSelect({ conceptName: localSelected });
              onClose();
            }
          }}
        >
          {i18n('common.apply')}
        </button>
      </div>
    </div>
  );
};
